import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

const PublicRoute = ( {
  component, layout: Layout, ...rest
} ) => (
  <Route {...rest}>
    <Layout component={component} />
  </Route>
);

PublicRoute.propTypes = {
  component: PropTypes.oneOfType( [PropTypes.object, PropTypes.func] ).isRequired,
  layout: PropTypes.oneOfType( [PropTypes.object, PropTypes.func] ).isRequired,
};

export default PublicRoute;
